import {ClientConfigType} from "@/app/config/configProvider";
import {getClientConfig, getServerConfig} from "@/app/config/serverConfig";

let browserConfig: ClientConfigType | undefined = undefined

export async function getConfig() {
    if (typeof window === 'undefined') {
        // Server: always return server config
        return await getServerConfig()
    } else {
        // Browser: make a new config if we don't already have one
        // This is very important, so we don't re-make a new client if React
        // suspends during the initial render. This may not be needed if we
        // have a suspense boundary BELOW the creation of the query client
        if (!browserConfig) browserConfig = await getClientConfig()
        return browserConfig
    }
}
